import React from "react";
import style from "./BotaoSalvar.module.css";
import { Button } from "react-bootstrap";
import { MdSave } from "react-icons/md";

function BotaoSalvar({ isDisabled, onClick }) {
  return (
    <Button className={style.botao_salvar} onClick={onClick} variant="primary" type="submit" disabled={isDisabled}>
      <MdSave /> Salvar
    </Button>
  );
}

export default BotaoSalvar;
